import React, { useEffect, useState } from "react";
import { Button, Modal, Input, Select, DatePicker, Checkbox } from 'antd';
import type { SelectProps } from 'antd';
import moment from "moment";
import "./CreateModel.less";
import { pricingApi, useEditPricingPlanV2Mutation } from 'services/pricingService';
import Notification from "common/components/NotificationMessage/Notification";

export default function
    ({ open, handleOk, handleCancel, editModelData, pricingPlans }) {

    const [station, setStation] = useState<string>('');
    const [level2PricingPlan, setLevel2PricingPlan] = useState<string>('');
    const [dCFCPricingPlan, setDCFCPricingPlan] = useState<string>('');


    useEffect(() => {
        if (editModelData) {
            setStation(editModelData.station)
            setLevel2PricingPlan(editModelData.level2PricingPlan)
        }
    }, [editModelData])

    const cancelTap = () => {
        handleCancel()
    }

    const [editPricingPlan, { isSuccess: editPricingPlanSuccess, data: editPricingPlanData }] = useEditPricingPlanV2Mutation();

    useEffect(() => {
        if (editPricingPlanSuccess) {
            Notification({
                type: editPricingPlanData?.success ? "success" : "warning",
                message: editPricingPlanData?.success ? "save update pricing plan success" : "save update pricing plan failed",
                description: "",
            });
            handleCancel();
        }

    }, [editPricingPlanSuccess]);

    const saveTap = () => {
        editPricingPlan({
            station,
            unifiedPricingPlanName: level2PricingPlan,
        });
    }

    const options = pricingPlans.map((item) => {
        return {
            value: item,
            label: item
        }
    })

    return (
        <Modal
            visible={open}
            title="Modify"
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
            width={600}
        >
            <div className='model-content'>
                <div className='model-content-item'>
                    <p>station #: </p>
                    <div style={{ width: 320 }}>{station}</div>
                </div>
                <div className='model-content-item'>
                    <p>PricingPlan: </p>
                    {/* <Input style={{ width: 320 }} placeholder="level2PricingPlan"
                        value={level2PricingPlan} onChange={(e) => setLevel2PricingPlan(e.target.value)} /> */}
                    <Select
                        value={level2PricingPlan}
                        style={{ width: 320 }}
                        onChange={(e) => setLevel2PricingPlan(e)}
                        options={options}
                    />
                </div>
                <div className='model-last-btn'>
                    <Button type="primary" danger size='large'
                        style={{ margin: "10px 0", height: '50px', width: '50%', background: '#FD6B7E' }}
                        onClick={() => cancelTap()}>cancel</Button>
                    <Button type="primary" danger size='large'
                        style={{
                            background: '#FF9F39', border: '1px solid #FF9F39', height: '50px',
                            width: '50%', fontSize: '20px', fontWeight: '800'
                        }} onClick={() => saveTap()}>save</Button>
                </div>
            </div>
        </Modal>
    )
}
